// extracted by mini-css-extract-plugin
export default {"search":"materials_search__tbert","fieldList":"materials_fieldList__Qfb6O","field":"materials_field__uXd0V","count":"materials_count__mS3bu","list":"materials_list__AnYT7"};